export default __webpack_public_path__ + "static/media/799aad88b840e76f9452f412564d298a.svg";